import { ITabTemplate } from '../shared/tabs/i-tab-template';

export const TAB_TEMPLATES: ITabTemplate[] = [
  {
    name: 'projectlist',
    caption: 'Project List',
    url: '/features/projectlist',
    closeable: false,
    static: true
  },
  {
    name: 'uploaddata',
    caption: 'Upload Data',
  }
];
